import { TimePickerProps, TimeRangePickerProps } from "antd";
import { MAX_DAY_END_TIME, TIME_FORMAT } from "common/Calendars/constants.ts";

const useEventTimePicker = () => {
  const disabledTime: TimePickerProps["disabledTime"] = (current) => {
    const hour = current?.hour();
    const allowedMinutes = [0, 15, 30, 45];
    if (hour === MAX_DAY_END_TIME[0]) {
      allowedMinutes.push(MAX_DAY_END_TIME[1]);
    }

    const disabledMinutes = Array.from({ length: 60 }, (_, i) =>
      allowedMinutes.includes(i) ? null : i
    ).filter((v): v is number => v !== null);

    return {
      disabledMinutes: () => disabledMinutes,
    };
  };

  const props: TimeRangePickerProps = {
    format: TIME_FORMAT,
    use12Hours: true,
    hideDisabledOptions: true,
    inputReadOnly: true,
    disabledTime,
    needConfirm: false,
  };

  return { props };
};

export default useEventTimePicker;
